import React from 'react';
import StylovyzeDialog from '@innovyze/stylovyze/lib/components/StylovyzeDialog';
const WarningDialog = (props) => {
    return (React.createElement(StylovyzeDialog, { ...props, confirmButtonProps: { ...props.confirmButtonProps, color: 'error' } }));
};
export default WarningDialog;
